import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { SoftwareManagementSoftwareSetupContractItemFragment } from 'generated/resources/graphql'
import moment from 'moment'

import DocumentType from 'modules/core/components/DocumentType'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { get12HFormat } from 'modules/core/lib/formatTime'

import ContractActions from './_ContractActions'

interface Props {
  contract: SoftwareManagementSoftwareSetupContractItemFragment
  softwareSetupId: number
}
const ContractItem = ({ contract, softwareSetupId }: Props) => {
  const { access } = useCurrentSession()

  const formattedDatetime = () => {
    const date = moment(contract.createdAt)
    const formattedDate = date.format('ll')

    const time = date.format('HH:mm')
    const formattedTime = access.timeFormat == 24 ? time : get12HFormat(time)

    return `${formattedDate}, ${formattedTime}`
  }

  return (
    <Box
      flexGrow
      padding="s16"
      borderRadius={{
        all: 'abs008',
      }}
      border={{
        all: {
          style: 'solid',
          width: 's1',
          color: 'grey400',
        },
      }}
    >
      <Box alignItems="center" flexDirection="row" gap="s16">
        <Box alignItems="center" flexGrow flexDirection="row" gap="s16">
          {contract.contentType && <DocumentType mimetype={contract.contentType} />}
          <Box gap="s4">
            <Text.Normal weight="medium" ellipsis>
              {contract.filename}
            </Text.Normal>
            <Text.Normal size="200" color="grey800" ellipsis>
              {formattedDatetime()}
            </Text.Normal>
          </Box>
        </Box>
        <Box flexDirection="row" gap="s8">
          <ContractActions contract={contract} softwareSetupId={softwareSetupId} />
        </Box>
      </Box>
    </Box>
  )
}

export default ContractItem
